export const CHART_WIDGET_TYPE_ID = 'ChartWidget';
